<div class="container-scc" *ngIf="isScc ; else mypacs">
  <div class="container">
    <div class="top-bar">
      <div class="top-bar-container">
        <div class="environment" *ngIf="!isProd">{{ environment }}</div>
        <ng-container [ngTemplateOutlet]="userSection" *ngIf="preferences?.preferenciesObject"></ng-container>
      </div>
    </div>

    <div class="bottom-bar">
      <div class="logo-container" [routerLink]="isFinalizingAccount ? null : '/'" [class.disabled]="isFinalizingAccount">
        <img src="/assets/img/scc/logo.png" alt="SCC logo">
      </div>

      <nav *ngIf="preferences?.preferenciesObject">
        <ul>
          <li *ngIf="canUploadStudyScc && clinics.length">
            <a mat-flat-button routerLink="/upload" routerLinkActive="current-page">{{'mainNav.links.upload_study' | translate}}</a>
          </li>
          <li>
            <a routerLink="/dashboard" routerLinkActive="current-page">{{'mainNav.links.dashboard' | translate}}</a>
          </li>
          <li *ngIf="canUploadStudyScc && clinics.length && selectedClinic?.isGroup === false">
            <a routerLink="/clinic-payment-method" routerLinkActive="current-page">{{'mainNav.links.payment_method' | translate}}</a>
          </li>
          <li *ngIf="isAdmin">
            <a routerLink="/clinics" routerLinkActive="current-page">{{'mainNav.links.clinics' | translate}}</a>
          </li>
          <li *ngIf="isAdmin">
            <a routerLink="/users" routerLinkActive="current-page">{{'mainNav.links.users' | translate}}</a>
          </li>
          <li>
            <a routerLink="/help" target="_blank" routerLinkActive="current-page">{{ 'mainNav.links.help' | translate }}</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>


<ng-template #mypacs>
  <div class="container-mypacs">
    <div class="container" *ngIf="preferences?.preferenciesObject">
      <div class="logo-container" routerLink="/studies">
        @switch (mode) {
        @case ('veokee') {
        <img class="logo" src="/assets/img/veokee/logo/logo-veokee.svg" alt="Veokee logo">
        <i>
          Powered by
          <img *ngIf="!preferences.preferenciesObject.isDarkMode" src="/assets/img/logo/logo-light-theme.svg" alt="MyPacs logo" height="25">
          <img *ngIf="preferences.preferenciesObject.isDarkMode" src="/assets/img/logo/logo-dark-theme.svg" alt="MyPacs logo" height="25">
        </i>
        }
        @default {
        <img class="logo" *ngIf="!preferences.preferenciesObject.isDarkMode" src="/assets/img/logo/logo-light-theme.svg" alt="MyPacs logo">
        <img class="logo" *ngIf="preferences.preferenciesObject.isDarkMode" src="/assets/img/logo/logo-dark-theme.svg" alt="MyPacs logo">
        }
        }
        <div class="environment" *ngIf="!isProd">{{ environment }}</div>
      </div>

      <nav>
        <ul>
          <li>
            <a routerLink="/studies" routerLinkActive="current-page">{{'mainNav.links.studies' | translate}}</a>
          </li>
          <li *ngIf="canReadClinic && this.clinics && !hasNoClinics">
            <a routerLink="/clinics" routerLinkActive="current-page">{{'mainNav.links.clinics' | translate}}</a>
          </li>

          <span class="list-separator"></span>

          <li *ngFor="let item of pinnedItems | slice:0:6; let i=index;" [ngSwitch]="getNavItem(item.navItem)">
            <ng-template [ngSwitchCase]="NavItemName.WORKLIST">
              <a routerLink="/worklist" routerLinkActive="current-page">{{'mainNav.links.worklist' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.ATLAS">
              <a routerLink="/albums" routerLinkActive="current-page">{{'mainNav.links.albums' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.DASHBOARD">
              <a routerLink="/dashboard" routerLinkActive="current-page">{{'mainNav.links.dashboard' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.USERS">
              <a routerLink="/users" routerLinkActive="current-page">{{'mainNav.links.users' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.VETS">
              <a routerLink="/refering-vet" routerLinkActive="current-page">{{'mainNav.links.referent' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.DICOMIZER">
              <a routerLink="/dicomizer" routerLinkActive="current-page">{{'mainNav.links.dico' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.TEMPLATES">
              <a routerLink="/report-templates" routerLinkActive="current-page">{{'mainNav.links.templates' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.CATEGORIES">
              <a routerLink="/disciplined" routerLinkActive="current-page">{{'mainNav.links.categories' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.TAGS">
              <a routerLink="/keywords" routerLinkActive="current-page">{{'mainNav.links.keywords' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.HEADER">
              <a routerLink="/report-header" routerLinkActive="current-page">{{'mainNav.links.headers' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.TXT_MAIL">
              <a routerLink="/mail-configuration" routerLinkActive="current-page">{{'mainNav.links.txtMail' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.RADIO">
              <a routerLink="/radio-protection" routerLinkActive="current-page">{{'mainNav.links.radio' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.REPORTS">
              <a routerLink="/reports" routerLinkActive="current-page">{{'mainNav.links.reports' | translate}}</a>
            </ng-template>
            <ng-template [ngSwitchCase]="NavItemName.ALERTS">
              <a routerLink="/important-alerts" routerLinkActive="current-page">{{'mainNav.links.importantAlerts' | translate}}</a>
            </ng-template>
          </li>

          <span class="list-separator" *ngIf="!hasNoClinics"></span>

          <li class="more-options" *ngIf="!hasNoClinics" [matMenuTriggerFor]="moreOptions" (menuOpened)="menuOpened()" (menuClosed)="menuClosed()">
            <div>{{'mainNav.button.tools' | translate}}</div>
            <span class="material-icons-outlined"> expand_more </span>
          </li>
          <mat-menu #moreOptions="matMenu">
            <ul class="options-list">
              <li *ngFor="let navItem of displayedNavPref">
                <ng-container [ngSwitch]="getNavItem(navItem.navItem)">
                  <ng-template [ngSwitchCase]="NavItemName.WORKLIST">
                    <a routerLinkActive="current-page" routerLink="/worklist">{{'mainNav.links.worklist' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.ATLAS">
                    <a routerLinkActive="current-page" routerLink="/albums">{{'mainNav.links.albums' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.DASHBOARD">
                    <a routerLinkActive="current-page" routerLink="/dashboard">{{'mainNav.links.dashboard' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.USERS">
                    <a routerLinkActive="current-page" routerLink="/users">{{'mainNav.links.users' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.VETS">
                    <a routerLinkActive="current-page" routerLink="/refering-vet">{{'mainNav.links.referent-FullLabel' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.DICOMIZER">
                    <a routerLinkActive="current-page" routerLink="/dicomizer">{{'mainNav.links.dico' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.TEMPLATES">
                    <a routerLinkActive="current-page" routerLink="/report-templates">{{'mainNav.links.templates' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.CATEGORIES">
                    <a routerLinkActive="current-page" routerLink="/disciplined">{{'mainNav.links.categories-FullLabel' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.TAGS">
                    <a routerLinkActive="current-page" routerLink="/keywords">{{'mainNav.links.keywords' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.HEADER">
                    <a routerLinkActive="current-page" routerLink="/report-header">{{'mainNav.links.headers-FullLabel' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.TXT_MAIL">
                    <a routerLinkActive="current-page" routerLink="/mail-configuration">{{'mainNav.links.txtMail-FullLabel' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.BLOC_MAIL">
                    {{'mainNav.links.email-FullLabel' | translate}}
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.RADIO">
                    <a routerLinkActive="current-page" routerLink="/radio-protection">{{'mainNav.links.radio' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.REPORTS">
                    <a routerLinkActive="current-page" routerLink="/reports">{{'mainNav.links.reports' | translate}}</a>
                  </ng-template>
                  <ng-template [ngSwitchCase]="NavItemName.ALERTS">
                    <a routerLinkActive="current-page" routerLink="/important-alerts">{{'mainNav.links.importantAlerts' | translate}}</a>
                  </ng-template>
                </ng-container>

                <span *ngIf="!navItem.pinned" class="material-icons-outlined" (click)="pinItem($event, navItem)"> push_pin </span>
                <span *ngIf="navItem.pinned" class="material-icons" (click)="pinItem($event, navItem)"> push_pin </span>
              </li>
            </ul>
          </mat-menu>
        </ul>
      </nav>

      <ng-container [ngTemplateOutlet]="userSection"></ng-container>
    </div>
  </div>
</ng-template>

<ng-template #userSection>
  <div class="profil-container">
    <button mat-icon-button (click)="showSupportModal()" [matTooltip]="'support.tooltip' | translate" *ngIf="!isScc">
      <mat-icon>support_agent</mat-icon>
    </button>
    <app-popup-notification></app-popup-notification>
    <button mat-icon-button (click)="showBugReportModal()" matTooltip="Informations de debug" *ngIf="!isProd">
      <mat-icon>bug_report</mat-icon>
    </button>

    <!-- Separate Clinic Selection -->
    <div class="clinic-selector" *ngIf="clinics && (clinics.length > 1 || myPacsClinics.length > 0)" [matMenuTriggerFor]="clinicMenu" (menuOpened)="onClinicMenuOpened()">
      <div class="clinic-picture">
        <img [src]="apiUrl + '/file/' + selectedClinic.logoUrl | authenticatedUrl" alt="Logo" width="40" height="40" *ngIf="selectedClinic?.logoUrl; else emptyClinicLogo">
        <ng-template #emptyClinicLogo>
          <div class="empty-clinic-picture">
            <mat-icon>medical_information</mat-icon>
          </div>
        </ng-template>
      </div>
      <div class="clinic-info">
        <span class="clinic-name" [matTooltip]="clinicName ?? ''" [matTooltipShowDelay]="700">{{clinicName}}</span>
      </div>
      <span class="material-icons-outlined"> expand_more </span>
    </div>

    <!-- Account Section -->
    <div class="account-user-menu" [matMenuTriggerFor]="userMenu">
      <div class="account-picture">
        <img src="/assets/img/default-avatar.png" alt="User Avatar" width="40" height="40" *ngIf="false; else defaultAvatar">
        <ng-template #defaultAvatar>
          <div class="default-account-picture">
            <mat-icon>account_circle</mat-icon>
          </div>
        </ng-template>
      </div>
      <div class="account-info">
        <span class="account-name">{{userName}}</span>
      </div>
      <span class="material-icons-outlined"> expand_more </span>
    </div>
  </div>

  <!-- Clinic Selection Menu -->
  <mat-menu #clinicMenu="matMenu" [xPosition]="'before'">
    <div class="clinic-menu" (click)="onMenuClick($event)">
      <div class="clinic-header">
        <label>{{'mainNav.clinic-choice' | translate}}</label>
      </div>
      <div class="clinic-search" *ngIf="clinics && (clinics.length + myPacsClinics.length) > 5">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>{{'mainNav.search-clinics' | translate}}</mat-label>
          <input matInput [(ngModel)]="clinicSearchTerm" (input)="filterClinics()" placeholder="{{'mainNav.search-clinics-placeholder' | translate}}">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      <div class="change-clinic radio-height">
        <div *ngIf="getGroupNames().length === 0 && filteredMyPacsClinics.length === 0 && clinicSearchTerm" class="no-results-message">
          {{'mainNav.no-clinics-found' | translate}}
        </div>
        <mat-radio-group [(ngModel)]="selectedClinic" (change)="clinicChange($event)" class="two-column-layout">
          <div *ngFor="let groupName of getGroupNames()" class="clinic-group">
            <div class="group-header" *ngIf="shouldShowGroupHeader(groupName)">
              <ng-container *ngIf="getGroupClinic(groupName) as groupClinic; else nonSelectableHeader">
                <mat-radio-button color="primary"
                  [value]="groupClinic"
                  [title]="'Sélectionner le groupe: ' + groupName"
                  class="group-header-selectable">
                  <span class="group-clinic-indicator">📁</span>
                  <strong>{{groupName}} ({{groupedClinics[groupName].length}})</strong>
                </mat-radio-button>
              </ng-container>
              <ng-template #nonSelectableHeader>
                <strong>{{groupName}} ({{groupedClinics[groupName].length}})</strong>
              </ng-template>
            </div>
            <mat-radio-button color="primary"
              *ngFor="let clinic of groupedClinics[groupName]"
              [value]="clinic"
              [title]="clinic.name"
              [class.group-child]="shouldShowGroupHeader(groupName) && !clinic.isGroup"
              [class.group-parent]="clinic.isGroup">
              <span *ngIf="clinic.isGroup" class="group-clinic-indicator">📁</span>
              {{clinic.shortName}}
            </mat-radio-button>
          </div>

          <!-- Section MyPacs pour super admin SCC -->
          <div *ngIf="filteredMyPacsClinics.length > 0" class="clinic-group mypacs-section">
            <div class="group-header">
              <strong>Cliniques MyPacs ({{ filteredMyPacsClinics.length }})</strong>
            </div>
            <mat-radio-button color="primary"
              *ngFor="let clinic of filteredMyPacsClinics"
              [value]="clinic"
              [title]="clinic.name"
              class="group-child">
              {{clinic.shortName || clinic.name}}
            </mat-radio-button>
          </div>
        </mat-radio-group>
      </div>
    </div>
  </mat-menu>

  <!-- User Account Menu -->
  <mat-menu #userMenu="matMenu" [xPosition]="'before'">
    <div class="user-menu" (click)="onMenuClick($event)">

      <div *ngIf="!isScc">
        <div class="change-lang">
          <mat-form-field appearance="outline" class="language-selector">
            <mat-label>{{ 'mainNav.language_choice' | translate }}</mat-label>
            <mat-select [(value)]="selectedLanguage" (selectionChange)="switchLang($event.value)">
              <mat-select-trigger>
                <span class="flag-option">
                  <span class="flag-icon">{{getFlagIcon(selectedLanguage)}}</span>
                  <span class="language-name">{{'mainNav.' + selectedLanguage | translate}}</span>
                </span>
              </mat-select-trigger>
              <mat-option
                *ngFor="let lang of translateService.getLangs()"
                [value]="lang">
                <span class="flag-option">
                  <span class="flag-icon">{{getFlagIcon(lang)}}</span>
                  <span class="language-name">{{'mainNav.' + lang | translate}}</span>
                </span>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <span class="separator"></span>

        <button mat-menu-item (click)="switchTheme()">
          <mat-icon>{{ preferences.preferenciesObject.isDarkMode ? 'light_mode' : 'dark_mode' }}</mat-icon>
          <span>{{ (preferences.preferenciesObject.isDarkMode ? 'mainNav.theme-light-mode' : 'mainNav.theme-dark-mode') | translate }}</span>
        </button>
      </div>

      <span class="separator" *ngIf="!isScc"></span>

      <button mat-menu-item *ngIf="isScc && canUploadStudyScc && clinics.length && selectedClinic?.isGroup === false" routerLink="/clinic-payment-method">
        <mat-icon>payments</mat-icon>
        {{'mainNav.links.payment_method' | translate}}
      </button>

      <button mat-menu-item [routerLink]="['my-account']">
        <mat-icon>account_circle</mat-icon>
        {{ 'mainNav.button.my_account' | translate }}
      </button>

      <button mat-menu-item [routerLink]="['billing']" *ngIf="!isScc && (selectedClinic?.isMyPacs === true || selectedClinic?.hasMyPacsAccess === true) && canSeeBilling">
        <mat-icon>credit_card</mat-icon>
        {{ 'mainNav.button.billing' | translate }}
      </button>

      <button mat-menu-item [routerLink]="['admin-dashboard']" *ngIf="!isScc && isAdmin">
        <mat-icon>admin_panel_settings</mat-icon>
        {{ 'mainNav.button.admin-dashboard' | translate }}
      </button>

      <button mat-menu-item [routerLink]="['pms-integrations']" *ngIf="isPms && !isScc">
        <mat-icon>sync_alt</mat-icon>
        {{ 'mainNav.button.pmsIntegrations' | translate }}
      </button>

      <app-ping-pacs *ngIf="!isScc"></app-ping-pacs>

      <a mat-menu-item *ngIf="!isScc" href="/assets/CGV.MYPACS.2023.VF.pdf" target="_blank">
        <mat-icon>gavel</mat-icon>
        {{ 'mainNav.button.CGV' | translate }}
      </a>

      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        {{'mainNav.button.disconnect' | translate}}
      </button>
    </div>
  </mat-menu>
</ng-template>
